import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './LoginPage.css';

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'login',
      },
    });
  };

  const handleSignUp = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
      },
    });
  };

  return (
    <div className="login-page">
      {/* Header with Logo */}
      <div className="login-header">
        <img
          src="/next-generation-logo.svg"
          alt="Next Generation"
          className="login-logo"
        />
      </div>

      <div className="login-container">
        {/* Section 1: Process Explanation */}
        <div className="process-section">
          <h1>Pre-Onboarding Data Collection</h1>
          <p className="process-description">
            Welcome to Next Generation. This secure portal allows you to
            complete your pre-onboarding application at your own pace. You can save your
            progress and return anytime to continue where you left off.
          </p>

          <div className="process-steps">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Sign In or Create Account</h3>
                <p>Use your credentials or create a new account to get started</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Complete Application Sections</h3>
                <p>Fill out company details, contact information, and required documentation</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Submit for Review</h3>
                <p>Once complete, submit your application for processing</p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: Authentication Actions */}
        <div className="auth-section">
          <div className="auth-card">
            <h2>Get Started</h2>
            <p className="auth-description">
              Choose an option below to access your pre-onboarding application
            </p>

            <div className="auth-actions">
              <button
                className="btn btn-primary btn-lg"
                onClick={handleLogin}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 17L15 12L10 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Sign In
              </button>

              <button
                className="btn btn-secondary btn-lg"
                onClick={handleSignUp}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20 8V14M17 11H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Create Account
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="login-footer">
        <p>&copy; 2024 Next Generation. All rights reserved.</p>
      </div>
    </div>
  );
};

export default LoginPage;